import clsx from 'clsx'
import map from 'lodash/map'
import React, { memo, VFC } from 'react'
import styled from 'styled-components'

import { svgURL } from '@Globals/Cloudinary'

export const ShippingOptionWrapper = styled.div(({ theme }) => `
  align-items: center;
  border-bottom: 1px solid ${theme.colors.greyLighter};
  display: flex;
  font-size: 0.875rem;
  padding: 15px 0;

  &:first-child {
    border-top: 1px solid ${theme.colors.greyLighter};
  }
`)

export const DeliveryDetail = styled.div({})

export const ShippingOptionLogoWrapper = styled.div({
  flex: '0 0 70px',
  height: 42,
  marginRight: 15,
  position: 'relative',
  width: 70,
})

export const ShippingOptionLogo = styled.img({
  height: 'auto',
  left: '50%',
  maxHeight: '100%',
  position: 'absolute',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
})

export const DeliveryTimeDetails = styled.span(() => (({
  display: 'inline-block',

  '&:after, &:before': {
    color: 'inherit',
  },

  '&:after': {
    content: '")"',
  },
  '&:before': {
    content: '"("',
  },
})))

export const DeliveryPrice = styled.div({
  flexGrow: 2,
  flexShrink: 0,
  fontWeight: 'bold',
  textAlign: 'right',
})

export const OptionsWrapper = styled.div({
  marginBottom: 25,
})

export type ShippingOptionProps = {
  companyId: string
  deliveryTime: string
  price: string
  thresholdPrice: string
  thresholdPriceIsFree: boolean
  type: string
}

interface ShippingOptionsProps {
  options: ShippingOptionProps[]
}

const ShippingOption: VFC<ShippingOptionProps> = memo(({ companyId, deliveryTime, price, type }) => (
  <ShippingOptionWrapper>
    <ShippingOptionLogoWrapper>
      <ShippingOptionLogo
        alt=""
        className={clsx(companyId === 'ups' && 'ups')}
        loading="lazy"
        src={svgURL(`frontend/shipping-logos/${companyId}.svg`)}
      />
    </ShippingOptionLogoWrapper>
    <DeliveryDetail>
      {type}
      {' '}
      <DeliveryTimeDetails dangerouslySetInnerHTML={{ __html: deliveryTime }} />
    </DeliveryDetail>
    <DeliveryPrice>{price}</DeliveryPrice>
  </ShippingOptionWrapper>
))

export const ShippingOptions: VFC<ShippingOptionsProps> = memo(({ options }: ShippingOptionsProps) => (
  <OptionsWrapper>
    {map(
      options,
      (({ companyId, type, ...option }: ShippingOptionProps) => (
        <ShippingOption
          key={companyId + type}
          companyId={companyId}
          type={type}
          {...option}
        />
      )),
    )}
  </OptionsWrapper>
))
